import client from '../httpClient';

const directGetListApi = (params) => {
  return client.post('/directs/list', params, { isShowLoading: false });
};

export default directGetListApi;
